import { CustomFieldsFormWebComponent } from './component/CustomFieldsFormWebComponent';
import { WEB_COMPONENT_CUSTOM_FIELDS_FORM } from '../../../webcomponents.constants';

export { CustomFieldsFormWebComponent };

window.customElements.define(WEB_COMPONENT_CUSTOM_FIELDS_FORM, CustomFieldsFormWebComponent);
